<i18n>
{
	"en": {
		"title": "Clerk"
	},
	"no": {
		"title": "Ansvarlig"
	}
}
</i18n>

<template>
	<div>
		<t-combobox-button
			ref="comboboxButton"
			:title="$t('title')"
			icon="person"
			:limit="$options.SERVER_RETURN_LIMIT"

			:searchValue="searchValue"
			:items="filteredItems"
			:selected="value"

			:disabled="disabled"
			disableButtonTabbing

			@focus="onFocus"
			@input="onInput"
			@change="onChange"
			@blur="onBlur"
			@button:click="setShowDialog(true)"
		>
			<template v-slot:optionItemContent="slotProps">
				<div class="item">
					<div class="item-main-text">{{ slotProps.item.name }}</div>
				</div>
			</template>
		</t-combobox-button>

		<clerks-form-input-dialog
			:items="clerks"
			:isShown="showDialog"
			:initialSearchValue="searchValue"
			icon="person"
			@close="setShowDialog(false)"
			@ok="onChange"
		/>
	</div>
</template>

<script>
import baseStore from '@/store';
import { mapState, mapActions } from './store/clerks.store.js';
import ClerksFormInputDialog from './ClerksFormInput/ClerksDialog';
import TComboboxButton from '@/components/evergreen/timpex/inputs/TComboboxButton';

export default {
	name: 'ClerkInput',
	components: { TComboboxButton, ClerksFormInputDialog },
	props: {
		value: Object,
		disabled: {
			type: Boolean,
			default: false
		},
		focusNextOnSelected: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			showDialog: false,
			searchValue: '',
			focused: false
		};
	},
	computed: {
		...mapState(['clerks']),

		filteredItems() {
			return this.clerks.filter( item => {

				if (!item)
					return false;

				let loweredSearchValue = this.searchValue.toLowerCase();

				let ret = true;
				for (let c of loweredSearchValue.split(' ')) {
					ret = ret &&
						(item.name && item.name.toLowerCase().includes(c));
				}
				return ret;
			});
		}
	},
	watch: {
		value: {
			immediate: true,

			handler(value) {
				this.searchValue = this.getSearchValueFromValue(value);
			}
		}
	},
	async mounted() {
		await this.getClerks();
		let user = baseStore.getters['login/getUser'];
		let clerk = this.clerks.find(x => x.id === user.uid);
		if (clerk) {
			this.$nextTick(() => this.$emit('change', clerk));
		}
	},
	methods: {
		...mapActions(['getClerks']),
		onFocus() {
			this.focused = true;
		},
		onInput(searchValue) {
			this.searchValue = searchValue;
		},
		onChange(event) {
			this.searchValue = this.getSearchValueFromValue(event);

			this.$emit('change', event);

			if (this.focusNextOnSelected && Object.keys(event).length) {
				window.focusNext({ target: this.$refs.comboboxButton.$el.querySelector('input') });
			}
		},
		onBlur(event) {

			this.focused = false;

			if (!isRelatedTargetButton(event, this.$refs.comboboxButton)) {

				if (this.searchValue === '')
					this.$emit('change', {});

				else
					this.searchValue = this.getSearchValueFromValue(this.value);
			}

			function isRelatedTargetButton(event, comboboxButtonRef) {

				return event.relatedTarget
					=== comboboxButtonRef.$refs.textInputButton.$refs.iconButton.$el;
			}
		},
		onSelect(event) {
			this.$emit('change', event);
			if (this.focusNextOnSelected && Object.keys(event).length) {
				window.focusNext({ target: this.$refs.input.$el.querySelector('input') });
			}
		},
		getSearchValueFromValue(value) {

			if (value && value.name && value.name.length)
				return value.name;
			else
				return '';
		},
		setShowDialog(showDialog) {

			if (this.showDialog === true && showDialog === false)
				this.searchValue = this.getSearchValueFromValue(this.value);

			this.showDialog = showDialog;
		},
	},
};
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/colors';
@import '~@/components/evergreen/scss/text';

.details {
	@extend %text-small;
	color: get-color($text, 'muted');
	padding-left: 10px;
}
</style>
